<template>
  <div class="newGroupingShpKml no-select">
    <!-- 新增分组 -->
    <MapModal
      class="newModelPosition hierarchy2"
      :modalNode="modalNode"
      :title="newGroupingCategory.title"
      :id="newGroupingCategory.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="80px"
          @submit.native.prevent
        >
          <el-form-item
            label="选择类型"
            prop="modelName"
            v-if="isAutoComplete.isShow"
          >
            <el-select
              v-model="form.modelName"
              placeholder="请选择类型"
              :popper-append-to-body="false"
              value-key="id"
            >
              <el-option
                v-for="(item, index) in importDataType"
                :key="index"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else prop="test"></el-form-item>
          <el-form-item label="分组名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入分组名称"
            ></el-input>
          </el-form-item>
          <el-form-item class="submitBtn btns">
            <el-button @click="closeOneSelf">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>
<script>
import _ from "lodash";
import { addKmlInfo, addShpInfo, editKmlInfo, editShpInfo } from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "newGroupingKmlShp",
  components: { MapModal },
  props: ["isAutoComplete"],
  data() {
    return {
      newGroupingCategory: {
        title: "新建分组",
        id: "newGrouping", // id和ref使用的同一个
      },
      modalNode: {
        newGroupingCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -730,
          // },
          // width: "450px", // 宽度配置 默认450px
          height: "200px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
        },
      },
      rules: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        modelName: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
      },
      form: {
        name: "",
        modelName: {
          name: "KML",
          type: 1,
          id: 1,
        },
      },
      importDataType: [
        {
          name: "KML",
          type: 1,
          id: 1,
        },
        {
          name: "SHP",
          type: 2,
          id: 2,
        },
      ],
    };
  },
  methods: {
    // 关闭自己
    closeOneSelf() {
      this.form = {
        name: "",
        modelName: "",
      };
      this.$emit("closeNewGrouping");
    },
    // 提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let groupingType = null;
          const { value } = this.isAutoComplete;
          const { modelName, name } = this.form;
          groupingType = modelName?.type;
          const params = {
            projectId: sessionStorage.getItem("nowProjectId"),
            pid: 0,
            type: true,
            activation: true,
          };
          if (value && value == "KmlInfo") {
            groupingType = 1;
          }
          if (value && value == "ShpInfo") {
            groupingType = 2;
          }
          // 新增
          if (!this.isAutoComplete.groupingEdit) {
            // KML
            if (groupingType == 1) {
              params.kmlName = name;
              addKmlInfo(params).then((res) => {
                this.SubmitSuccessfully("新增KML分组", formName);
              });
            }
            // SHP
            if (groupingType == 2) {
              params.shpName = name;
              addShpInfo(params).then((res) => {
                this.SubmitSuccessfully("新增SHP分组", formName);
              });
            }
          } else {
            // 编辑
            params.id = this.isAutoComplete.id;
            // KML
            if (groupingType == 1) {
              params.kmlName = name;
              editKmlInfo(params).then((res) => {
                let { code } = res.data;
                if (code == 200 || code == 204) {
                  this.SubmitSuccessfully("编辑KML分组", formName);
                } else {
                  this.$notify({
                    title: "编辑失败",
                    message: "",
                    type: "error",
                    duration: 960,
                    offset: 320,
                  });
                }
              });
            }
            // SHP
            if (groupingType == 2) {
              params.shpName = name;
              editShpInfo(params).then((res) => {
                this.SubmitSuccessfully("编辑SHP分组", formName);
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关于保存提交之后的统一操作
    SubmitSuccessfully(name, formName) {
      // 通知栏
      this.$notify({
        title: `${name}成功。`,
        message: "",
        type: "success",
        duration: 960,
        offset: 320,
      });
      // // 清除表单
      this.$refs[formName].resetFields();
      // 发送事件给父组件告知提交完毕
      this.$emit("addNewGroupingSuccess");
      // 关闭自己弹窗
      this.closeOneSelf();
    },
    // 编辑分组回显名字
    editGrouping() {
      this.$refs["form"].resetFields();
      if (this.isAutoComplete.groupingEdit) {
        this.newGroupingCategory.title = "编辑分组";
        this.form.name = this.isAutoComplete.title;
      } else {
        this.newGroupingCategory.title = "新建分组";
        this.form.name = "";
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/box.scss";
.newGroupingShpKml {
  @include box_wh(320, 560, true, 386);
  padding: 0;
  overflow-y: auto;
  h3 {
    text-indent: 14px;
  }
  .el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding: 8px 0 14px 0;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }
      &.file-upload {
        margin-bottom: 6px;
        /*避免动画效果导致滚动条出现*/
        max-height: 120.3px;
        overflow-y: hidden;
        .el-form-item__label {
          align-self: flex-start;
        }
        .el-form-item__content {
          .upload-demo {
            .el-upload__input {
              display: none;
            }
            .el-upload {
              .el-button--default {
                @include lheight(26);
                @include font_color("t_color_op2");
                @include background_color("t_color3_op2");
                @include border_color("t_color_op2");
                padding: 0 10px;
                margin: 0;
                span {
                  @include lheight(24);
                  font-size: 12px;
                  display: block;
                  text-align: center;
                }
                &:hover {
                  @include background_color("t_color3_op1");
                  @include border_color("t_color_op1");
                  @include font_color("t_color_op1");
                }
              }
            }
            .el-upload__tip {
              margin-top: 0px;
              @include lheight(22);
              span {
                @include font_color("t_color_op2");
                @include lheight(22);
              }
            }
            .el-upload-list {
              .el-upload-list__item {
                //去掉动画效果
                //transition: none !important;

                margin-top: 0px;
                background: none;
                a {
                  @include font_color("t_color_op2");
                }
                .el-upload-list__item-name {
                  margin-right: 20px;
                  @include font_color("t_color_op2");
                  @include textOverflow();
                  font-size: 12px;
                  max-width: 200px;
                  i {
                    @include font_color("t_color_op2");
                  }
                }
                .el-upload-list__item-status-label {
                  line-height: 22px;
                  .el-icon-upload-success {
                    @include font_color("t_color_op2");
                    line-height: 22px;
                  }
                }
                i {
                  top: 4px;
                  @include font_color("t_color_op2");
                  &.el-icon-close-tip {
                    display: none;
                  }
                }
                .el-progress {
                  .el-progress-bar__inner {
                    @include background_color("t_color1_op2");
                  }
                  .el-progress__text {
                    @include font_color("t_color_op2");
                  }
                }
                &:first-child {
                  margin-top: 0px;
                }
                &:hover {
                  @include background_color("slide_color_op1");
                  .el-upload-list__item-name {
                    @include font_color("t_color_op1");
                    i {
                      @include font_color("t_color_op1");
                    }
                  }
                  i.el-icon-close {
                    @include font_color("t_color_op1");
                  }
                }
              }
            }
          }
        }
      }
      &.color-pick {
        margin-bottom: 2px;
        .el-color-picker {
          /* height: 26px !important; */
          height: 20px !important;
          line-height: 20px !important;
          width: 20px;
          padding: 0;

          .el-color-picker__trigger {
            border: none;
            height: 20px !important;
            line-height: 20px !important;
            width: 20px;
            padding: 0;
            .el-color-picker__color {
              border: none;
            }
            span.el-icon-arrow-down {
              // display: none;
            }
          }
        }
        span.label-text {
          @include font_color("t_color_op1");
          margin-left: 16.5px;
        }
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
  }
}

.el-color-dropdown.icon-color-picker {
  .el-color-dropdown__main-wrapper {
    // display: none;
  }
  .el-color-dropdown__btns {
    .el-color-dropdown__value {
      // display: none;
    }
  }
  .el-color-predefine {
    .el-color-predefine__colors {
      .el-color-predefine__color-selector {
        border: 1px solid #2ca9e1;
        box-sizing: border-box;
      }
    }
  }
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #f6f6f6 !important;
}
.el-autocomplete-suggestion li {
  color: #606266 !important;
  font-size: 12px;
}
.el-autocomplete-suggestion li:hover {
  @include background_color("t_color1_op1");
  color: white !important;
  font-size: 12px;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: white !important;
}
.el-radio-group {
  margin-top: 7px;
}
.el-radio {
  white-space: break-spaces;
  word-break: break-all;
  .el-radio__input {
    line-height: 18px;
    .el-radio__inner {
      margin: 0 3px 0 0;
      @include background_color("t_color3_op2");
      &::after {
        /* 取消选中状态单选框中间的小圆点显示 */
        display: none;
      }
      &:hover {
        @include border_color("t_color1_op1");
      }
    }
    &.is-checked {
      .el-radio__inner {
        // @include border_color('t_color1_op1');
        // @include background_color('t_color1_op1');
        @include border_color("th_color_op1");
        @include background_color("th_color_op1");
      }
    }
  }
  .el-radio__label {
    padding-left: 2px;
    font-size: 12px !important;
    color: white;
  }
  &.is-checked {
    .el-radio__label {
      @include font_color("t_color_op1");
    }
    .el-radio__inner {
      @include background_color("t_color1_op1");
    }
  }
}

.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
</style>
